import {
  ActivityChangeExtensionOptions,
  createActivityChangeExtension,
  createActivityChangeExtensions,
  useActivityChangeExtensions,
} from '@spotify/plugin-confidence-activity-react';

export const MetricUpdatesChangeExtensions = createActivityChangeExtensions(
  'metric-updates-change',
);

export const useMetricUpdatesChangeExtensions = () => {
  return useActivityChangeExtensions(MetricUpdatesChangeExtensions);
};

export const createMetricUpdatesChangeExtension = (
  options: ActivityChangeExtensionOptions,
) => {
  return createActivityChangeExtension(options);
};
